import { VERIFICATION } from '../constants';
import { IEX_STATE_CODES } from '@constants/configs/states';

const verificationsHelper = () => {
    const getDropdownOptions = (documentsList, language) => {
        return [
            { text: VERIFICATION.SELECT_OPTION[language], value: '' },
            ...(language === 'en'
                ? Object.keys(documentsList[0]).map(englishEntries => ({ text: englishEntries, value: englishEntries }))
                : Object.entries(documentsList[0]).map(([englishEntries, spanishEntries]) => ({
                    text: spanishEntries,
                    value: englishEntries,
                }))),
        ];
    };

    const getFileNameWithAmount = (filename, amount) => {
        const lastIndex = filename.lastIndexOf('.');
        const name = filename.slice(0, lastIndex);
        const extension = filename.slice(lastIndex);
        return amount < 0 ? `${name}-(${amount})${extension}` : `${name}-${amount}${extension}`;
    };

    const calculateTotalAmount = data => {
        return data.reduce((total, item) => total + item.amount, 0);
    };

    const isNonIncomeDMI = (docCategory) => {
        return ['Citizenship', 'Lawful Presence', 'Death', 'Incarceration Status', 'Minimum Essential Coverage', 'Non-ESI Minimum Essential Coverage', 'Residency', 'Social Security Number', 'American Indian/Alaska Native Status'].includes(docCategory);
    };

    const isSelfEmploymentDocumentValid = (stateCode, document) => {
        const documentsByState = {
            NJ: [
                'Profit and loss statement (for self-employed)',
                '1040 form (federal tax return) with Schedule 1',
                'Rental Income (Schedule 1, rent checks or receipt, current lease)',
                'Other taxable income'
            ],
            OTHER: [
                '1040 SE with Schedule C,F,SE (for self-employment income)',
                '1065 Schedule K1 with Schedule E',
                'Bookkeeping records',
                'Most recent quarterly or year-to-date profit and loss statement',
                'Receipts for all allowable expenses',
                'Signed time sheets and receipt of payroll, if you have employees',
                'Tax return'
            ]
        };
    
        const stateDocuments = stateCode === IEX_STATE_CODES.NJ ? documentsByState.NJ : documentsByState.OTHER;
        return stateDocuments.includes(document);
    };

    const createKeyboardHandler = handler => e => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handler();
        }
    };

    const generateCorrelationId = () =>
        typeof crypto?.randomUUID === 'function'
            ? crypto.randomUUID()
            : `${Date.now()}-${Math.random().toString(36).slice(2)}`;

    return {
        getDropdownOptions,
        getFileNameWithAmount,
        calculateTotalAmount,
        isNonIncomeDMI,
        isSelfEmploymentDocumentValid,
        createKeyboardHandler,
        generateCorrelationId,
    };
};

export default verificationsHelper;